module.exports = __webpack_public_path__ + "img/flag-IT.7905f6ed.png";